// Operators.jsx
import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { apiCall } from '../../utils/api';
import toast, { Toaster } from 'react-hot-toast';
import { FaSearch, FaEdit, FaTrash, FaPlus, FaToggleOn, FaToggleOff } from "react-icons/fa";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

function Operators() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState('dashboard');
    const [operators, setOperators] = useState([]);
    const [filteredOperators, setFilteredOperators] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showFilters, setShowFilters] = useState(true);

    // Modal states
    const [operatorModalOpen, setOperatorModalOpen] = useState(false);
    const [selectedOperator, setSelectedOperator] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const navigate = useNavigate();

    // Pagination states
    const [pagination, setPagination] = useState({
        currentPage: 1,
        perPage: 10,
        totalRecords: 0,
        totalPages: 1
    });

    // Filter states
    const [filters, setFilters] = useState({
        searchValue: '',
        status: '',
        category: '',
        subCategory: '',
        companyBelong: '',
        isBBPS: '',
        amountExactness: '',
        paymentChannel: '',
        activePaymentMode: '',
        minAmount: '',
        maxAmount: '',
        dateFrom: '',
        dateTo: ''
    });

    // Status options
    const statusOptions = [
        { id: '', name: 'All Status' },
        { id: '1', name: 'Active' },
        { id: '0', name: 'Inactive' }
    ];

    // Category options
    const categoryOptions = [
        { id: '', name: 'All Categories' },
        { id: 'Broadband Postpaid', name: 'Broadband Postpaid' },
        { id: 'Cable TV', name: 'Cable TV' },
        { id: 'Clubs and Associations', name: 'Clubs and Associations' },
        { id: 'Credit Card', name: 'Credit Card' },
        { id: 'DTH', name: 'DTH' },
        { id: 'Education Fees', name: 'Education Fees' },
        { id: 'Electricity', name: 'Electricity' },
        { id: 'Fastag', name: 'Fastag' },
        { id: 'Gas', name: 'Gas' },
        { id: 'Health Insurance', name: 'Health Insurance' },
        { id: 'Hospital', name: 'Hospital' },
        { id: 'Hospital and Pathology', name: 'Hospital and Pathology' },
        { id: 'Housing Society', name: 'Housing Society' },
        { id: 'Insurance', name: 'Insurance' },
        { id: 'Landline Postpaid', name: 'Landline Postpaid' },
        { id: 'Life Insurance', name: 'Life Insurance' },
        { id: 'Loan Repayment', name: 'Loan Repayment' },
        { id: 'LPG Gas', name: 'LPG Gas' },
        { id: 'Mobile Postpaid', name: 'Mobile Postpaid' },
        { id: 'Municipal Services', name: 'Municipal Services' },
        { id: 'Municipal Taxes', name: 'Municipal Taxes' },
        { id: 'Postpaid', name: 'Postpaid' },
        { id: 'Prepaid', name: 'Prepaid' },
        { id: 'Recurring Deposit', name: 'Recurring Deposit' },
        { id: 'Redeem Code', name: 'Redeem Code' },
        { id: 'Subscription', name: 'Subscription' },
        { id: 'Water', name: 'Water' },
        { id: 'Donation', name: 'Donation' },
        { id: 'Prepaid Meter', name: 'Prepaid Meter' }
    ];

    // Sub Category options
    const subCategoryOptions = [
        { id: '', name: 'All Sub Categories' },
        { id: 'BBPS', name: 'BBPS' },
        { id: 'Non BBPS', name: 'Non BBPS' }
    ];

    // Company Belong options
    const companyBelongOptions = [
        { id: '', name: 'All Companies' },
        { id: 'Internal', name: 'Internal' },
        { id: 'BillAvenue', name: 'BillAvenue' },
        { id: 'Mobikwik', name: 'Mobikwik' }
    ];

    // Is BBPS options
    const isBBPSOptions = [
        { id: '', name: 'All' },
        { id: '0', name: 'No' },
        { id: '1', name: 'Yes' }
    ];

    // Amount Exactness options
    const amountExactnessOptions = [
        { id: '', name: 'All' },
        { id: 'As per Plan', name: 'As per Plan' },
        { id: 'Exact', name: 'Exact' },
        { id: 'Exact and above', name: 'Exact and above' },
        { id: 'Exact and below', name: 'Exact and below' },
        { id: 'NA', name: 'NA' }
    ];

    // Payment Channel options
    const paymentChannelOptions = [
        { id: '', name: 'All' },
        { id: 'AGT', name: 'AGT' },
        { id: 'INT', name: 'INT' },
        { id: 'MOB', name: 'MOB' },
        { id: 'NA', name: 'NA' }
    ];

    // Active Payment Mode options
    const activePaymentModeOptions = [
        { id: '', name: 'All' },
        { id: 'Cash', name: 'Cash' },
        { id: 'UPI', name: 'UPI' },
        { id: 'Net Banking', name: 'Net Banking' }
    ];

    // Form state for add/edit
    const [formData, setFormData] = useState({
        biller_name: '',
        bbps_id: '',
        biller_id: '',
        category: '',
        sub_category: '',
        logo: '',
        status: '1',
        companyBelong: '',
        isBBPS: '0',
        isBillFetchRequired: '0',
        circle: '',
        amountExactness: 'As per Plan',
        paymentChannel: 'NA',
        paymentModes: '',
        activePaymentMode: 'Cash',
        isAdhoc: '0',
        isBillValidation: '0',
        billAmountOptions: '',
        billerDescription: '',
        MIN: 10,
        MAX: 100000
    });

    // Fetch Operators with pagination
    const fetchOperators = async (page = 1) => {
        setLoading(true);
        try {
            const params = {
                searchValue: filters.searchValue,
                status: filters.status,
                category: filters.category,
                subCategory: filters.subCategory,
                companyBelong: filters.companyBelong,
                isBBPS: filters.isBBPS,
                amountExactness: filters.amountExactness,
                paymentChannel: filters.paymentChannel,
                activePaymentMode: filters.activePaymentMode,
                minAmount: filters.minAmount,
                maxAmount: filters.maxAmount,
                dateFrom: filters.dateFrom,
                dateTo: filters.dateTo,
                page: page,
                limit: pagination.perPage
            };

            const result = await apiCall(
                "operators-list",
                params,
                true
            );

            if (result.status === true) {
                setOperators(result.data || []);
                setFilteredOperators(result.data || []);
                if (result.pagination) {
                    setPagination(result.pagination);
                }
            } else {
                toast.error(result.message || "Failed to fetch operators");
                setOperators([]);
                setFilteredOperators([]);
            }
        } catch (error) {
            toast.error("Network error. Please try again.");
            setOperators([]);
            setFilteredOperators([]);
        } finally {
            setLoading(false);
        }
    };

    // Handle Add Operator
    const handleAddOperator = () => {
        setIsEditMode(false);
        setFormData({
            biller_name: '',
            bbps_id: '',
            biller_id: '',
            category: '',
            sub_category: '',
            logo: '',
            status: '1',
            companyBelong: '',
            isBBPS: '0',
            isBillFetchRequired: '0',
            circle: '',
            amountExactness: 'As per Plan',
            paymentChannel: 'NA',
            paymentModes: '',
            activePaymentMode: 'Cash',
            isAdhoc: '0',
            isBillValidation: '0',
            billAmountOptions: '',
            billerDescription: '',
            MIN: 10,
            MAX: 100000
        });
        setSelectedOperator(null);
        setOperatorModalOpen(true);
    };

    // Handle Edit Operator
    const handleEditOperator = (operator) => {
        setIsEditMode(true);
        setSelectedOperator(operator);
        setFormData({
            biller_name: operator.biller_name || '',
            bbps_id: operator.bbps_id || '',
            biller_id: operator.biller_id || '',
            category: operator.category || '',
            sub_category: operator.sub_category || '',
            logo: operator.logo || '',
            status: operator.status_id || '1',
            companyBelong: operator.companyBelong || '',
            isBBPS: operator.isBBPS || '0',
            isBillFetchRequired: operator.isBillFetchRequired || '0',
            circle: operator.circle || '',
            amountExactness: operator.amountExactness || 'As per Plan',
            paymentChannel: operator.paymentChannel || 'NA',
            paymentModes: operator.paymentModes || '',
            activePaymentMode: operator.activePaymentMode || 'Cash',
            isAdhoc: operator.isAdhoc || '0',
            isBillValidation: operator.isBillValidation || '0',
            billAmountOptions: operator.billAmountOptions || '',
            billerDescription: operator.billerDescription || '',
            MIN: operator.MIN || 10,
            MAX: operator.MAX || 100000
        });
        setOperatorModalOpen(true);
    };

    // Handle Delete Operator
    const handleDeleteOperator = (operator) => {
        Swal.fire({
            title: 'Delete Operator?',
            text: `Are you sure you want to delete "${operator.biller_name}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'Cancel'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await apiCall(
                        "delete-operator",
                        {
                            operator_id: operator.operator_id
                        },
                        true
                    );

                    if (response.status === true) {
                        toast.success("Operator deleted successfully!");
                        fetchOperators(pagination.currentPage);
                    } else {
                        toast.error(response.message || "Failed to delete operator");
                    }
                } catch (error) {
                    toast.error("Network error. Please try again.");
                }
            }
        });
    };

    // Handle Status Toggle
    const handleStatusToggle = (operator) => {
        const newStatus = operator.status === 'Active' ? '0' : '1';
        const statusName = operator.status === 'Active' ? 'Inactive' : 'Active';

        Swal.fire({
            title: `Toggle Status?`,
            text: `Are you sure you want to change "${operator.biller_name}" to ${statusName}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Toggle!',
            cancelButtonText: 'Cancel'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await apiCall(
                        "toggle-operator-status",
                        {
                            operator_id: operator.operator_id,
                            status: newStatus
                        },
                        true
                    );

                    if (response.status === true) {
                        toast.success(`Operator ${statusName} successfully!`);
                        fetchOperators(pagination.currentPage);
                    } else {
                        toast.error(response.message || "Failed to toggle status");
                    }
                } catch (error) {
                    toast.error("Network error. Please try again.");
                }
            }
        });
    };

    // Handle Save Operator (Add/Update)
    const handleSaveOperator = async () => {
        if (!formData.biller_name.trim()) {
            toast.error("Please enter operator name");
            return;
        }

        if (!formData.category) {
            toast.error("Please select a category");
            return;
        }

        try {
            const endpoint = isEditMode ? "update-operator" : "add-operator";
            const params = isEditMode
                ? { operator_id: selectedOperator.operator_id, ...formData }
                : formData;

            const response = await apiCall(endpoint, params, true);

            if (response.status === true) {
                toast.success(isEditMode ? "Operator updated successfully!" : "Operator added successfully!");
                setOperatorModalOpen(false);
                fetchOperators(pagination.currentPage);
            } else {
                toast.error(response.message || "Failed to save operator");
            }
        } catch (error) {
            toast.error("Network error. Please try again.");
        }
    };

    // Initial fetch
    useEffect(() => {
        fetchOperators(1);
    }, []);

    // Apply filters
    const applyFilters = () => {
        fetchOperators(1);
    };

    // Reset filters
    const resetFilters = () => {
        setFilters({
            searchValue: '',
            status: '',
            category: '',
            subCategory: '',
            companyBelong: '',
            isBBPS: '',
            amountExactness: '',
            paymentChannel: '',
            activePaymentMode: '',
            minAmount: '',
            maxAmount: '',
            dateFrom: '',
            dateTo: ''
        });
        fetchOperators(1);
    };

    // Handle page change
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            fetchOperators(newPage);
        }
    };

    // Handle filter change
    const handleFilterChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    };

    // Get status color
    const getStatusColor = (status) => {
        const colors = {
            'Active': 'bg-green-100 text-green-800',
            'Inactive': 'bg-red-100 text-red-800'
        };
        return colors[status] || 'bg-gray-100 text-gray-800';
    };

    // Get category color
    const getCategoryColor = (category) => {
        const colors = {
            'Prepaid': 'bg-blue-100 text-blue-800',
            'Postpaid': 'bg-green-100 text-green-800',
            'DTH': 'bg-purple-100 text-purple-800',
            'Electricity': 'bg-yellow-100 text-yellow-800',
            'Gas': 'bg-orange-100 text-orange-800',
            'Water': 'bg-cyan-100 text-cyan-800'
        };
        return colors[category] || 'bg-gray-100 text-gray-800';
    };

    return (
        <div className="bg-gray-50 font-sans antialiased min-h-screen">
            {/* Mobile Overlay */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-40 lg:hidden"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            <Sidebar
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                isOpen={sidebarOpen}
                setIsOpen={setSidebarOpen}
            />

            <div className="main-content lg:ml-[72px] transition-all duration-200">
                <Header
                    currentPage={currentPage}
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                />

                <div className="p-4 sm:p-6 lg:p-8">
                    {/* Page Title */}
                    <div className="mb-6 flex justify-between items-center flex-wrap gap-2">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900">Operators</h1>
                            <p className="text-gray-600 text-sm">View and manage all operators</p>
                        </div>
                        <button
                            onClick={handleAddOperator}
                            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200 text-sm flex items-center gap-2"
                        >
                            <FaPlus />
                            Add Operator
                        </button>
                    </div>

                    {/* Filter Section */}
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6 overflow-hidden">
                        <div className={`p-4 sm:p-6 ${showFilters ? 'block' : 'hidden lg:block'}`}>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                                {/* Row 1: Search */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Search</label>
                                    <div className="relative">
                                        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                                        <input
                                            type="text"
                                            value={filters.searchValue}
                                            onChange={(e) => handleFilterChange('searchValue', e.target.value)}
                                            placeholder="Search by name..."
                                            className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                        />
                                    </div>
                                </div>

                                {/* Status */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                                    <select
                                        value={filters.status}
                                        onChange={(e) => handleFilterChange('status', e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                    >
                                        {statusOptions.map(option => (
                                            <option key={option.id} value={option.id}>{option.name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Category */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
                                    <select
                                        value={filters.category}
                                        onChange={(e) => handleFilterChange('category', e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                    >
                                        {categoryOptions.map(option => (
                                            <option key={option.id} value={option.id}>{option.name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Sub Category */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Sub Category</label>
                                    <select
                                        value={filters.subCategory}
                                        onChange={(e) => handleFilterChange('subCategory', e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                    >
                                        {subCategoryOptions.map(option => (
                                            <option key={option.id} value={option.id}>{option.name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Company Belong */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Company Belong</label>
                                    <select
                                        value={filters.companyBelong}
                                        onChange={(e) => handleFilterChange('companyBelong', e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                    >
                                        {companyBelongOptions.map(option => (
                                            <option key={option.id} value={option.id}>{option.name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Is BBPS */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Is BBPS</label>
                                    <select
                                        value={filters.isBBPS}
                                        onChange={(e) => handleFilterChange('isBBPS', e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                    >
                                        {isBBPSOptions.map(option => (
                                            <option key={option.id} value={option.id}>{option.name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Amount Exactness */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Amount Exactness</label>
                                    <select
                                        value={filters.amountExactness}
                                        onChange={(e) => handleFilterChange('amountExactness', e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                    >
                                        {amountExactnessOptions.map(option => (
                                            <option key={option.id} value={option.id}>{option.name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Payment Channel */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Payment Channel</label>
                                    <select
                                        value={filters.paymentChannel}
                                        onChange={(e) => handleFilterChange('paymentChannel', e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                    >
                                        {paymentChannelOptions.map(option => (
                                            <option key={option.id} value={option.id}>{option.name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Active Payment Mode */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Active Payment Mode</label>
                                    <select
                                        value={filters.activePaymentMode}
                                        onChange={(e) => handleFilterChange('activePaymentMode', e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                    >
                                        {activePaymentModeOptions.map(option => (
                                            <option key={option.id} value={option.id}>{option.name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Min Amount */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Min Amount</label>
                                    <input
                                        type="number"
                                        value={filters.minAmount}
                                        onChange={(e) => handleFilterChange('minAmount', e.target.value)}
                                        placeholder="Enter min amount..."
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                    />
                                </div>

                                {/* Max Amount */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Max Amount</label>
                                    <input
                                        type="number"
                                        value={filters.maxAmount}
                                        onChange={(e) => handleFilterChange('maxAmount', e.target.value)}
                                        placeholder="Enter max amount..."
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                    />
                                </div>

                                {/* Date Range */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Date Range</label>
                                    <div className="flex gap-2">
                                        <input
                                            type="date"
                                            value={filters.dateFrom}
                                            onChange={(e) => handleFilterChange('dateFrom', e.target.value)}
                                            className="w-1/2 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                        />
                                        <input
                                            type="date"
                                            value={filters.dateTo}
                                            onChange={(e) => handleFilterChange('dateTo', e.target.value)}
                                            className="w-1/2 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                        />
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className="flex gap-2 items-end">
                                    <button onClick={applyFilters} className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200 text-sm">Apply</button>
                                    <button onClick={resetFilters} className="flex-1 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200 text-sm">Reset</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Results Count */}
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
                        <p className="text-sm text-gray-600">
                            Showing <span className="font-semibold text-gray-900">{filteredOperators.length}</span> operators
                            {pagination.totalRecords > 0 && ` of ${pagination.totalRecords}`}
                        </p>
                        {loading && (
                            <div className="flex items-center text-sm text-gray-500">
                                <svg className="animate-spin h-4 w-4 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                </svg>
                                Loading...
                            </div>
                        )}
                    </div>

                    {/* Operators Table */}
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sub Category</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {filteredOperators.length > 0 ? (
                                        filteredOperators.map((operator) => (
                                            <tr key={operator.operator_id} className="hover:bg-gray-50 transition-colors duration-150">
                                                <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-blue-600 cursor-pointer" onClick={() =>
                                                    navigate(`/margin/setup`, {
                                                        state: { operator_id: operator.operator_id },
                                                    })
                                                }>#{operator.operator_id}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{operator.biller_name}</td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${getCategoryColor(operator.category)}`}>
                                                        {operator.category}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600">{operator.sub_category || 'N/A'}</td>
                                                <td className="px-4 py-3 whitespace-nowrap">
                                                    <div className="flex items-center gap-2">
                                                        <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(operator.status)}`}>
                                                            {operator.status}
                                                        </span>
                                                        <button onClick={() => handleStatusToggle(operator)} className="text-gray-500 hover:text-blue-600 transition-colors">
                                                            {operator.status === 'Active' ? <FaToggleOn className="text-2xl text-green-600" /> : <FaToggleOff className="text-2xl text-gray-400" />}
                                                        </button>
                                                    </div>
                                                </td>
                                                <td className="px-4 py-3">
                                                    <div className="flex items-center gap-2">
                                                        <button onClick={() => handleEditOperator(operator)} className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"><FaEdit className="text-sm" /></button>
                                                        <button onClick={() => handleDeleteOperator(operator)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"><FaTrash className="text-sm" /></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="px-4 py-8 text-center text-gray-500">
                                                <div className="flex flex-col items-center">
                                                    <svg className="w-12 h-12 text-gray-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                                                    </svg>
                                                    <p className="text-sm">No operators found</p>
                                                    <p className="text-xs text-gray-400 mt-1">Try adjusting your filters</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Pagination */}
                    {pagination.totalPages > 1 && (
                        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6">
                            <div className="text-sm text-gray-600">Page {pagination.currentPage} of {pagination.totalPages}</div>
                            <div className="flex gap-2">
                                <button onClick={() => handlePageChange(pagination.currentPage - 1)} disabled={pagination.currentPage === 1} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${pagination.currentPage === 1 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}>Previous</button>
                                <div className="flex gap-1">
                                    {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, i) => {
                                        let pageNum;
                                        if (pagination.totalPages <= 5) pageNum = i + 1;
                                        else if (pagination.currentPage <= 3) pageNum = i + 1;
                                        else if (pagination.currentPage >= pagination.totalPages - 2) pageNum = pagination.totalPages - 4 + i;
                                        else pageNum = pagination.currentPage - 2 + i;
                                        return (
                                            <button key={pageNum} onClick={() => handlePageChange(pageNum)} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${pagination.currentPage === pageNum ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}>{pageNum}</button>
                                        );
                                    })}
                                </div>
                                <button onClick={() => handlePageChange(pagination.currentPage + 1)} disabled={pagination.currentPage === pagination.totalPages} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${pagination.currentPage === pagination.totalPages ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}>Next</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Add/Edit Operator Modal */}
            {operatorModalOpen && (
                <div className="fixed inset-0 z-50 overflow-y-auto">
                    <div className="fixed inset-0 bg-black/50 transition-opacity" onClick={() => setOperatorModalOpen(false)}></div>
                    <div className="flex min-h-full items-center justify-center p-4">
                        <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">
                            <div className="flex-shrink-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900">{isEditMode ? 'Edit Operator' : 'Add New Operator'}</h3>
                                    <p className="text-sm text-gray-500">{isEditMode ? `Editing "${selectedOperator?.biller_name}"` : 'Create a new operator'}</p>
                                </div>
                                <button onClick={() => setOperatorModalOpen(false)} className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-lg">
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                                </button>
                            </div>

                            <div className="flex-1 overflow-y-auto p-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Operator Name <span className="text-red-500">*</span></label>
                                        <input type="text" value={formData.biller_name} onChange={(e) => setFormData({ ...formData, biller_name: e.target.value })} placeholder="Enter operator name..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">BBPS ID</label>
                                        <input type="text" value={formData.bbps_id} onChange={(e) => setFormData({ ...formData, bbps_id: e.target.value })} placeholder="Enter BBPS ID..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Biller ID</label>
                                        <input type="text" value={formData.biller_id} onChange={(e) => setFormData({ ...formData, biller_id: e.target.value })} placeholder="Enter biller ID..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Category <span className="text-red-500">*</span></label>
                                        <select value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm">
                                            <option value="">Select Category</option>
                                            {categoryOptions.filter(opt => opt.id !== '').map(option => (
                                                <option key={option.id} value={option.id}>{option.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Sub Category</label>
                                        <select value={formData.sub_category} onChange={(e) => setFormData({ ...formData, sub_category: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm">
                                            <option value="">Select Sub Category</option>
                                            <option value="BBPS">BBPS</option>
                                            <option value="Non BBPS">Non BBPS</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Logo URL</label>
                                        <input type="text" value={formData.logo} onChange={(e) => setFormData({ ...formData, logo: e.target.value })} placeholder="Enter logo URL..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                                        <select value={formData.status} onChange={(e) => setFormData({ ...formData, status: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm">
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Company Belong</label>
                                        <select value={formData.companyBelong} onChange={(e) => setFormData({ ...formData, companyBelong: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm">
                                            <option value="">Select Company</option>
                                            <option value="Internal">Internal</option>
                                            <option value="BillAvenue">BillAvenue</option>
                                            <option value="Mobikwik">Mobikwik</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Circle</label>
                                        <input type="text" value={formData.circle} onChange={(e) => setFormData({ ...formData, circle: e.target.value })} placeholder="Enter circle..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Amount Exactness</label>
                                        <select value={formData.amountExactness} onChange={(e) => setFormData({ ...formData, amountExactness: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm">
                                            <option value="As per Plan">As per Plan</option>
                                            <option value="Exact">Exact</option>
                                            <option value="Exact and above">Exact and above</option>
                                            <option value="Exact and below">Exact and below</option>
                                            <option value="NA">NA</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Payment Channel</label>
                                        <select value={formData.paymentChannel} onChange={(e) => setFormData({ ...formData, paymentChannel: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm">
                                            <option value="AGT">AGT</option>
                                            <option value="INT">INT</option>
                                            <option value="MOB">MOB</option>
                                            <option value="NA">NA</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Payment Modes</label>
                                        <input type="text" value={formData.paymentModes} onChange={(e) => setFormData({ ...formData, paymentModes: e.target.value })} placeholder="Enter payment modes..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Active Payment Mode</label>
                                        <select value={formData.activePaymentMode} onChange={(e) => setFormData({ ...formData, activePaymentMode: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm">
                                            <option value="Cash">Cash</option>
                                            <option value="UPI">UPI</option>
                                            <option value="Net Banking">Net Banking</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">MIN Amount</label>
                                        <input type="number" value={formData.MIN} onChange={(e) => setFormData({ ...formData, MIN: parseInt(e.target.value) || 10 })} placeholder="Enter MIN amount..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">MAX Amount</label>
                                        <input type="number" value={formData.MAX} onChange={(e) => setFormData({ ...formData, MAX: parseInt(e.target.value) || 100000 })} placeholder="Enter MAX amount..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm" />
                                    </div>
                                </div>
                            </div>

                            <div className="flex-shrink-0 bg-white border-t border-gray-200 px-6 py-3 flex justify-end gap-2">
                                <button onClick={() => setOperatorModalOpen(false)} className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200 text-sm">Cancel</button>
                                <button onClick={handleSaveOperator} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200 text-sm">{isEditMode ? 'Update' : 'Add'} Operator</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Toaster position="top-right" />
        </div>
    );
}

export default Operators;